import { MessageConversationSubscription } from '@/types/generated/graphql';
import { create } from 'zustand';

export type SwitchCallStoreType = {
  callId: number | null;
  showSwitchCall: boolean;
  agent: NonNullable<MessageConversationSubscription['messageConversation']>['agent'];
};

export const useSwitchCallStore = create<SwitchCallStoreType>(() => ({
  showSwitchCall: false,
  callId: null,
  agent: null,
}));
